import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import swal from "sweetalert2";
import * as fromRootStore from "./../../reducers";
import { Combo2Service } from "./../../services/index";
import { SaleDC } from "./../../services/salesDc.service";
import { WorkOrderService } from "./../../services/index";

import { PrintData } from "./../master/print/print";
declare var google;

@Component({
  selector: "salesInvoice",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./Plainmaster.html",
})
export class plainmaster implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  seasonList = [];
  printPreview: any;
  gridOptions: any;
  autoinv_no: any;
  dataList = [];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  shade_upd : boolean = false;
  invoiceTypeList = ["BOTH", "INVOICE", "PROFORMA"];


  filter = {
    design_no: "",
    shade: "",
 
    color: "",
  };
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "po_id",
    orderDir: "desc",
  };
  finyearList = [];
  agentList = [];
  seasonfinList = [];
  partyAgentList = [];
  partyList = [];
  invList = [];
  printData;

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("invoiceTemplate") invoiceTemplate: TemplateRef<any>;
  @ViewChild("box_printTemplate") box_printTemplate: TemplateRef<any>;
  @ViewChild("detailsTemplate") detailsTemplate: TemplateRef<any>;
  @ViewChild("convertWTemplate") convertWTemplate: TemplateRef<any>;
  @ViewChild("convertprofInv") convertprofInv: TemplateRef<any>;
  @ViewChild("convertWhofInv") convertWhofInv: TemplateRef<any>;
  @ViewChild("converttoEstimate") converttoEstimate: TemplateRef<any>;
  @ViewChild("convertRTemplate") convertRTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;
  @ViewChild("finAuto") finAuto;
  @ViewChild("partyAuto") partyAuto;

  finCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  agentCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  invCtrl: FormControl = new FormControl();
  columns = [];
  toggleCol = [];
  menu: any;
  print: boolean = false;
  noofpcs: number;
  box: boolean;
  shirt: boolean;
  reportName = "design_no";
  reportType = "Design";
  filterExpand = false;
  filterData: any;
  agentList$ = [];
  user: any;
  agentVisible: boolean = false;
  companyInfo: any = [];
  invoiceList: any = [];
  totpcs: any;

  constructor(
    public store: Store<fromRootStore.State>,
    private saleDC: SaleDC,
    public datePipe: DatePipe,
    private combo2Service: Combo2Service,
    private modalService: BsModalService,
    public toasterService: ToasterService,
    private salesinvservice: WorkOrderService
  ) { }

  ngOnInit(): void {
    this.getColumns();
    this.finyearCombo();

    // this.getInvoiceCombo();
    this.toggleCol = Object.assign({}, this.columns);
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  getColumns() {
  if(!this.shade_upd){
    this.columns = [
      {
        name: "SNo",
        prop: "sno",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        headerClass: "text-center",
        sortable: false,
        cellTemplate: this.snoTemplate,
        toggle: true,
        cellClass: "text-center",
      },
      {
        name: "Style",
        prop: "style",
        cellClass: "text-center",
        headerClass: "text-center",
        minWidth: 130,
        maxWidth: 130,
        width: 130,
      },
      {
        name: "Variety No",
        prop: "variety_no",
        cellClass: "text-center",
        headerClass: "text-center",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
      },
      {
        name: "Design No",
        prop: "core_designno",
        cellClass: "text-center",
        headerClass: "text-center",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
      },
      {
        name: "Party Name",
        prop: "party_name",
        headerClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
      {
        name: "Party Design",
        prop: "pdesign_no",
        headerClass: "text-center",
        cellClass: "text-left",
        minWidth: 150,
        maxWidth: 150,
        width: 150,
      },
      {
        name: "Shade",
        prop: "shade",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
      },
      {
        name: "Color",
        prop: "fabric_color",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
      },
      {
        name: "width",
        prop: "width",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 80,
        maxWidth: 80,
        width: 100,
      },
      {
        name: "Party Rate",
        prop: "party_rate",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
      {name: 'MRP',prop: 'mrp',headerClass:'text-center',cellClass: 'text-center', minWidth: 80,maxWidth: 80,width: 80 },
      {
        name: "Brand",
        prop: "brand",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
    
      {
        name: "Action",
        prop: "sno",
        minWidth: 80,
        maxWidth: 80,
        cellClass: "text-center",
        width: 50,
        sortable: false,
        cellTemplate: this.editDeleteTemplate,
      }
     
    ];

  }
else if(this.shade_upd){

  this.columns = [
    {
      name: "SNo",
      prop: "sno",
      minWidth: 80,
      maxWidth: 80,
      width: 80,
      headerClass: "text-center",
      sortable: false,
      cellTemplate: this.snoTemplate,
      toggle: true,
      cellClass: "text-center",
    },
    {
      name: "Style",
      prop: "style",
      cellClass: "text-center",
      headerClass: "text-center",
      minWidth: 130,
      maxWidth: 130,
      width: 130,
    },
    {
      name: "Design No",
      prop: "core_designno",
      cellClass: "text-center",
      headerClass: "text-center",
      minWidth: 80,
      maxWidth: 80,
      width: 80,
    },
    {
      name: "Party Name",
      prop: "party_name",
      headerClass: "text-center",
      minWidth: 120,
      maxWidth: 120,
      width: 120,
    },
    {
      name: "Party Design",
      prop: "pdesign_no",
      headerClass: "text-center",
      cellClass: "text-left",
      minWidth: 150,
      maxWidth: 150,
      width: 150,
    },
    {
      name: "Shade",
      prop: "shade",
      headerClass: "text-center",
      cellClass: "text-right",
      minWidth: 100,
      maxWidth: 100,
      width: 100,
    },
    {
      name: "Color",
      prop: "fabric_color",
      headerClass: "text-center",
      cellClass: "text-right",
      minWidth: 100,
      maxWidth: 100,
      width: 100,
    },

    {
      name: "Action",
      prop: "sno",
      minWidth: 80,
      maxWidth: 80,
      cellClass: "text-center",
      width: 50,
      sortable: false,
      cellTemplate: this.editDeleteTemplate,
    }
   
  ];

}
   
    this.toggleCol = Object.assign({}, this.columns);

  }

  onOpenedFilter(): void {
    let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
    a.removeClass("mat-autocomplete-visible");
    setTimeout(function () {
      $("#finyear").focus();
    }, 100);
  }

  printer() {
    // if(box_print == 'BOX'){
    //     this.noofpcs = 2;
    // }else if(box_print == 'SHIRT'){
    //     this.noofpcs = 1;
    // }
    this.noofpcs = 1;
    if ($("#box").is(":checked")) {
      this.box = true;
    } else {
      this.box = false;
    }
    if ($("#shirt").is(":checked")) {
      this.shirt = true;
    } else {
      this.shirt = false;
    }
    if (this.box == false && this.shirt == false) {
      swal("PLEASE SELECT ATLEAST ONE");
    } else {
      $("#box").prop("checked", false);
      $("#shirt").prop("checked", false);
    }
    let params = {
      noofpcs: this.noofpcs,
      box: this.box,
      shirt: this.shirt,
      designdet: JSON.stringify(this.printPreview),
    };
    this.saleDC.print(params).then((res: any) => { });
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
    this.salesInvoiceList();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      setTimeout(() => {
        $("#" + nextEl).focus();
      }, 300);
    }
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.salesInvoiceList();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    // this.getSalesinvReport();
    this.salesInvoiceList();
  }

  clearFilter(): void {

    this.filter.design_no = "";
    this.filter.shade = "";
    this.filter.color = "";
    this.shade_upd = false;
  
    this.applyFilter();
  }
  shadeUpdate(){
    this.shade_upd = true;
    this.applyFilter()
  }
  applyFilter(): void {
    this.filterPanel.close();
    // if (this.filter.ref_no == "") {
    //   this.filter.dcid = "";
    // }
   
    this.salesInvoiceList();
  }

  addEditPO(mode: string, row: any): void {
    let listUpdateEvent = new EventEmitter();
    listUpdateEvent.subscribe(() => {
      this.salesInvoiceList();
    });
    row.tabevent = listUpdateEvent;
    let tabObj = {};
    if (mode == "Add") {

   tabObj = {
        action: "NewTab",
        params: {
          //  tabParent: 'Transaction',
          tabName: "ADD RR MASTER",
          title: "ADD RR MASTER",
          tabParent: "COREGANG",
          mode: mode,
          data: row,
          name: "ADD RR MASTER",
          upd_type: this.shade_upd,
        },
      };




    }
    
 
    else if (mode == "Edit") {
      tabObj = {
        action: "NewTab",
        params: {
          tabName: "EDIT RR MASTER",
          title: "EDIT RR MASTER",
          tabParent: "COREGANG",
          mode: mode,
          data: row,
          name: "EDIT RR MASTER",
          upd_type: this.shade_upd,
        },
      };
    }
    this.tabUpdateEvent.emit(tabObj);
  }
  deletePlainMaster(row: any): void {
    let that = this;
    swal({
      title: 'Are you sure?',
      text: `Delete Style: ${row.style} - Design: ${row.core_designno}?`,
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, Delete',
      cancelButtonText: 'Cancel',
    }).then(
      function () {
        that.salesinvservice.deletePlainDetails({ id: row.id }).then((res: any) => {
          if (res.success) {
            that.toasterService.pop('success', 'Deleted', res.message);
            that.salesInvoiceList();
          } else {
            that.toasterService.pop('error', 'Error', res.message);
          }
        });
      },
      function (dismiss) {}
    );
  }

  salesInvoiceList(): void {
    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      page: "1",
    
      design_no: this.filter.design_no,
      shade: this.filter.shade,
      color: this.filter.color,
    };
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.salesinvservice
      .getplaindetails(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.page.count = res.total;
        that.invoiceList = res.data;
        that.getColumns();

        // if(that.shade_upd){
        //   for (let i = 0; i < that.invoiceList.length; i++) {
        //     that.invoiceList[i].shade_upd = that.shade_upd;  
        
        //   }
        // }
      });
  }
  


  bsModalRef: BsModalRef;
 

  finyearCombo() {
    let that = this;
    this.combo2Service.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
      //   that.finyearCtrl.setValue(res.data[0].fin_id);
      //       that.filter.finYrVal = res.data[0].finyear;
      //   that.filter.fin_year = res.data[0].finyear;
      that.pageCallback({ offset: 0 });
    });
  }

  // displayFn(comboType: string, id: number) {
  //   let list: any = [];
  //   if (comboType == "Finyear") {
  //     list = this.finyearList;
  //   }

  //   if (id && list.length > 0) {
  //     let fitem = _.find(list, { fin_id: id });
  //     this.filter.fin_year = fitem["finyear"];
  //     return fitem["finyear"];
  //   }
  //   return "";
  // }

  

  // displayFn1(comboType: string, id: number) {
  //   let list: any = [];
  //   let that = this;
  //   if (comboType == "Party") {
  //     list = this.partyList;
  //   }

  //   if (id && list.length > 0) {
  //     let fitem = _.find(list, { name: id });
  //     this.filter.party_id = fitem["genLedid"];
  //     return fitem["name"];
  //   }
  //   return "";
  // }

 

}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/master/Plainmaster.ts